import * as React from 'react';
import { Form as RRFForm, actions } from 'react-redux-form';
import { Loader } from '../Loader/Loader';
import { dispatch } from '../../../utils/generalUtils';

export interface IFormProps {
    model: string;
    onSubmit: (val) => void;
    loadDefaultValues?: Function;
    className?: string;
}

export interface IFormState {
    showSubmissionLoader: boolean;
}

export class Form extends React.PureComponent<IFormProps, IFormState> {
    constructor(props: IFormProps) {
        super(props);
        this.state = { showSubmissionLoader: false };
    }

    public componentDidMount() {
        if (this.props.loadDefaultValues) {
            this.props.loadDefaultValues();
        }
    }

    public componentWillMount() {
        dispatch(actions.reset(this.props.model));
    }

    public handleSubmit = async (values) => {
        const { onSubmit } = this.props;
        this.setState({
            showSubmissionLoader: true
        });
        try {
            await this.props.onSubmit(values);
            this.setState({
                showSubmissionLoader: false
            });
        } catch (error) {
            this.setState({
                showSubmissionLoader: false
            });
            throw error;
        }
    }

    public renderClonedChildren() {
        const childrenWithModelName = React.Children.map(this.props.children, child => {
            return React.cloneElement((child as React.ReactElement<any> || <span />), {
                formmodel: this.props.model
            });
        });
        return childrenWithModelName;
    }

    public render() {
        return <RRFForm className={this.props.className} model={this.props.model} onSubmit={this.handleSubmit} >
            {this.state.showSubmissionLoader ? <Loader key={1} type="submission" /> : ''}
            {this.renderClonedChildren()}
        </RRFForm>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/Form.tsx